import App from './src/components/App';

export const wrapRootElement = App;
